import { render, staticRenderFns } from "./uiObs3.vue?vue&type=template&id=4ba190e6"
import script from "./uiObs3.vue?vue&type=script&lang=js"
export * from "./uiObs3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports